const STAFF_HOME = {
    admin: '/admin',
    editor: '/admin/seiten',
    support: '/admin/tickets',
    readonly: '/admin/system',
};

const STAFF_PATHS = {
    editor: [
        '/admin/seiten', '/admin/medien', '/admin/navigation', '/admin/menues',
        '/admin/rechtliches', '/admin/branding', '/admin/firmendaten',
        '/admin/software', '/admin/referenzen', '/admin/formulare', '/admin/redirects',
    ],
    support: ['/admin/tickets'],
    readonly: ['/admin/system'],
};

export const isStaffRole = (role, forumRole = '') => Object.hasOwn(STAFF_HOME, role) || forumRole === 'moderator';

export const staffHomePath = (role, forumRole = '') => STAFF_HOME[role] || (forumRole === 'moderator' ? '/admin/forum' : '/portal');

export const canAccessAdminPath = (role, path, forumRole = '') => {
    if (role === 'admin') return path === '/admin' || path.startsWith('/admin/');
    if (path === '/admin') return isStaffRole(role, forumRole);
    if ((role === 'support' || forumRole === 'moderator') && (path === '/admin/forum' || path.startsWith('/admin/forum/'))) return true;
    return (STAFF_PATHS[role] || []).some(prefix => path === prefix || path.startsWith(`${prefix}/`));
};
